import React from "react";
import { connect } from "react-redux";
import { compose, lifecycle } from "recompose";

import Card from "react-md/lib/Cards/Card";
import CardText from "react-md/lib/Cards/CardText";

import Photo from "./Photo";
import Info from "./Info";
import Password from "./Password";
import Keys from "./Keys";

import { getUser } from "../../../actions/userActions";
import {DebugElement} from "../../../Atollon/debug";

const Profile = ({ user }) => {
  if (!user) return <div />;

  return (
    <Card className="profile">
        <DebugElement text={"src/components/settings/profile/index.js"}/>
      <CardText>
        <div className="flex-row flex-centered">
          <Photo />
          <div className="flex-col">
            <Info
              initialValues={{
                name: user.contact ? user.contact.name : "",
                firstName: user.contact ? user.contact.firstName : "",
                identifier: user.identifier
              }}
              user={user}
            />
            <Password user={user} />
          </div>
        </div>
        <Keys keys={user.authorizationKeys} />
      </CardText>
    </Card>
  );
};

export default compose(
  connect(({ app: { user } }) => ({ user }), { getUser }),
  lifecycle({
    async componentWillMount() {
      const { getUser } = this.props;

      getUser();
    }
  })
)(Profile);



// WEBPACK FOOTER //
// ./src/components/settings/profile/index.js